/** @module Apparel/StructureItemStyleTable */
define([
	"lodash",
	"dojo/_base/declare",
	"./StructureItemTable"
], function(_,declare,StructureItemTable) {

	return declare(StructureItemTable, {

		/** @property {reflist} selectedSharedSpecSections */
		selectedSharedSpecSections: null,

		/**
		 * Fix dependency paths by removing excess dependency paths with Index that
		 * increase query time on the database and only keeping the ones that 
		 * are needed to load LookupItems 
		 * @override
		 */
		onBuildColumns() {
			// Certain views don't have a view node and therefore don't have a store, and we shouldn't call this in those cases.
			if (this.getViewNode()) {
				const originalPaths = this.store.requestParameters['Dep.Path'];
				const fixedPaths = originalPaths.map((path => {
					const posIndex = path.lastIndexOf("/Index");
					const posMap = path.lastIndexOf("Child:SharedSpecItemDefinitionMap");
					const posLookup = path.lastIndexOf("Child:ValueLookupItem");
					return posIndex !== -1 && posMap === 0 && posLookup === -1 ? path.substring(0, posIndex) : path; 
				}));
				this.store.requestParameters['Dep.Path'] = _.uniq(fixedPaths);
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Update list of selected shared sections
		 */
		onViewCreate: function() {
			this.watch("selectedSharedSpecSections", (name, oldValue, newValue) => {
				this.selectedSharedSpecSections = newValue;
			});
			this.inherited(arguments);
		}
	});
});